import { render, staticRenderFns } from "./ViewCustomizer.vue?vue&type=template&id=6e20909b&"
import script from "./ViewCustomizer.vue?vue&type=script&lang=js&"
export * from "./ViewCustomizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports